<template>
  <div>
    <v-runtime-template :template="templateStr" :key="skey" />
  </div>
</template>

<script>

import template from "string-template";
import VRuntimeTemplate from "v-runtime-template";
import safeEval from 'notevil';
import {VBtn, VIcon, VChip, VAvatar, VRating, VProgressCircular, VProgressLinear} from 'vuetify/lib';

let defaults = {'textColor': '','class': '', 'color': '', 'value': '', 'icon': '', 'popup': '', 'link': '', size: '100', title: '', subtitle: '', width: '4', height: '', avatar: '', rotate: '', backgroundColor: ''};

function merge(d, p) {

  for (var prop in d) {
    if (Object.prototype.hasOwnProperty.call(d, prop)) {
      if(typeof p[prop] == 'undefined') {
        p[prop] = d[prop];
      } else if(!p[prop] || p[prop] == '') {
        p[prop] = d[prop];
      }
    }
  }
  //console.log(p);
  return p;
}

// <v-flex xs4 sm2 md1>
              
let uiHelpers = {
  ui_label: function(p) {
    let defaults = {'textColor': '','class': '', 'color': '', 'value': '', 'icon': '', 'popup': null, 'link': null};
    p = {...defaults, ...p};
    let t = "<v-btn color='{color}' class='{class}'>{value}</v-btn>";
    if(p.icon) {
      t = "<v-btn color='{color}' class='{class}' dark>{value}<v-icon dark right>{icon}</v-icon></v-btn>";
    }

    return template(t, p);
  },
  ui_chip: function(p) {
    let defaults = {'textColor': '','class': '', 'color': '', 'value': '', 'icon': '', 'popup': null, 'link': null};
    p = {...defaults, ...p};
    let t = "<v-chip color='{color}' text-color='{textColor}' class='{class}'>{value}</v-chip>";
    if(p.icon) {
      t = "<v-chip color='{color}' text-color='{textColor}' class='{class}'><v-avatar><v-icon>{icon}</v-icon></v-avatar>{value}</v-chip>";
    }
    return template(t, p);
  },
  ui_avatar: function(p) {
    let defaults = {'textColor': '','class': '', 'color': '', 'value': '', 'icon': '', 'popup': null, 'link': null, size: '42px'};
    p = {...defaults, ...p};
    let t = "<v-avatar size='{size}'><img src='{value}'></v-avatar>";
    return template(t, p);
  },
  ui_text_avatar: function(p) {
    let defaults = {'textColor': 'white--text','class': '', 'color': 'blue', 'value': '', 'icon': '', 'popup': null, 'link': null, size: '42px'};
    p = {...defaults, ...p};
    let t = "<v-avatar size='{size}' color='{color}'><span class='headline {textColor}'>{value}</span></v-avatar>";
    return template(t, p);
  },
  ui_rating: function(p) {
    let defaults = {'textColor': '','class': '', 'color': '', 'value': '', 'icon': '', 'popup': null, 'link': null};
    p = {...defaults, ...p};

    let t = "<v-rating :value='{value}' :readonly='true' background-color='purple lighten-3' color='purple'></v-rating>";
    return template(t, p);
  },
  ui_progressCircular: function(p) {
    p = merge({...defaults}, {...p});

    //console.log(p);
    p.title = typeof p.title != 'undefined' && p.title ? p.title : p.value;
    let t = '<v-progress-circular :size="{size}" :width="{width}" :value="{value}" color="{color}">{title}</v-progress-circular>';
    return template(t, p);
  },
  ui_progressLinear: function(p) {
    p = merge({...defaults}, {...p});
    p.title = typeof p.title != 'undefined' && p.title ? p.title : p.value;
    let t = '<v-progress-linear :size="{size}" :height="{height}" :value="{value}" color="{title}"></v-progress-linear>';
    return template(t, p);
  }

}
export default {
  name: 'dynamic-html',
  props: ['template', 'skey', 'chart'],
  data: function() {
      return {templateStr: '<span />'};
  },
  components: {
    'v-runtime-template': VRuntimeTemplate,
    'v-btn': VBtn,
    'v-icon': VIcon,
    'v-chip': VChip,
    'v-avatar': VAvatar,
    'v-rating': VRating,
    'v-progress-circular': VProgressCircular,
    'v-progress-linear': VProgressLinear
  },
  mounted() {
    this.templateStr = safeEval(this.template, uiHelpers);
    // console.log(this.templateStr);
  }
}
</script>
